export default __webpack_public_path__ + "static/media/c005-whatsapp-02.b00a8bcd.png";